import { render, staticRenderFns } from "./ChildBasicForm.vue?vue&type=template&id=698bbfb0&scoped=true"
import script from "./ChildBasicForm.vue?vue&type=script&lang=js"
export * from "./ChildBasicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698bbfb0",
  null
  
)

export default component.exports